// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"545":"7f47d65a","640":"c03e2bce"}[chunkId] + ".chunk.css";
};